import { IAboutNH } from '../models/about_nh'
import { IFlashNews } from '../models/flash_news'
import { IWhatToDoItem } from '../models/what_to_do'
import Api, { IApiResponse } from './index'
import { BaseUrl } from './base_url_enum'

type IGetAboutMembershipResponse = {
  aboutPreference: IAboutNH
}

type IGetAboutNHResponse = {
  aboutInsurance: IAboutNH
}

type IGetWhatToDoResponse = {
  myAppContents: IWhatToDoItem[]
}

type IGetFlashNewsResponse = {
  flashMessages: IFlashNews[]
}

export const getAboutMembership = () => Api<IApiResponse<IGetAboutMembershipResponse>>('GET', 'about-preferences', BaseUrl.Content)

export const getAboutNh = () => Api<IApiResponse<IGetAboutNHResponse>>('GET', 'about-nh1816-insurances', BaseUrl.Content)

export const getWhatToDo = () => Api<IApiResponse<IGetWhatToDoResponse>>('GET', 'my-app-contents', BaseUrl.Content)

export const getFlashNews = () => Api<IApiResponse<IGetFlashNewsResponse>>('GET', 'flash-messages', BaseUrl.Content)
